module.exports = __webpack_public_path__ + "d5402fcc701e8640d8a791b167e2ac9f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-07-04/whats-new.html
// module id = 2236
// module chunks = 0